import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndustryOverview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="36909" id="hero" ref={sectionRef} className="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/watch_movement_blueprint.png)] bg-cover bg-center opacity-10" />
        {}
        <div className="absolute inset-0 bg-background/40 mix-blend-multiply" />
        <div className="absolute inset-0 bg-background/20" /> {}
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <span className="inline-block text-primary font-mono text-sm md:text-base tracking-[0.2em] uppercase mb-6 font-medium">
            Manufacturing Excellence
          </span>

          {}
          <h1 className="font-sans font-bold text-foreground text-5xl md:text-7xl lg:text-[64px] tracking-[-0.02em] mb-8 leading-[1.1]">
            Start Your Watch Brand
            <br />
            <span className="text-primary">with Just 50 Pieces</span>
          </h1>

          {}
          <p className="font-sans text-secondary text-lg md:text-lg max-w-[700px] mx-auto mb-6 leading-relaxed font-light">
            Choose a ready‑made model, add your logo, and launch in 2–4 weeks — no large MOQ, no complex development.
          </p>

          <ul className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-10 text-secondary font-sans text-sm md:text-base font-medium">
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-primary" />
              MOQ from 50 pcs
            </li>
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-primary" />
              No sampling required
            </li>
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-primary" />
              Fast production (2–4 weeks)
            </li>
          </ul>

          {}
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground rounded-lg px-8 py-6 text-base font-semibold tracking-wide transition-all duration-300 shadow-lg hover:shadow-primary/20">
              <Link to="/CollectionPage">Start My Watch Project</Link>
            </Button>
            <Button asChild variant="outline" className="border-border text-foreground hover:bg-muted rounded-lg px-8 py-6 text-base font-semibold tracking-wide transition-all duration-300">
              <Link to="/CollectionPage">
                See Available Models
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <ChevronDown className="w-8 h-8 text-primary opacity-80" />
      </div>
    </section>;
}